"use client";

import Link from "@/components/no-prefetch-link";
import { usePathname } from "next/navigation";
import { ChevronRight, Home } from "lucide-react";
import { getBreadcrumbLabel } from "@/lib/breadcrumb";

/** 已有独立面包屑的页面，全局面包屑不再重复渲染 */
const INLINE_BREADCRUMB_PATHS = new Set([
  "/privacy",
  "/terms",
  "/cookies",
  "/about",
  "/methodology",
  "/guides/weibo-hot-search-history",
  "/guides/hot-search-engine",
]);

export function Breadcrumb() {
  const pathname = usePathname();
  const paths = pathname.split("/").filter(Boolean);

  if (pathname === "/") return null;
  if (INLINE_BREADCRUMB_PATHS.has(pathname)) return null;

  return (
    <nav className="flex items-center gap-1 text-sm text-muted-foreground py-2 px-4 container mx-auto">
      <Link
        href="/"
        className="flex items-center gap-1 hover:text-foreground transition-colors"
      >
        <Home className="w-3 h-3" />
        首页
      </Link>

      {paths.map((path, index) => {
        const href = "/" + paths.slice(0, index + 1).join("/");
        const isLast = index === paths.length - 1;
        const label = getBreadcrumbLabel(paths, index);

        return (
          <div key={path} className="flex items-center gap-1">
            <ChevronRight className="w-3 h-3" />
            {isLast ? (
              <span className="text-foreground font-medium truncate max-w-[200px]">
                {label}
              </span>
            ) : (
              <Link
                href={href}
                className="hover:text-foreground transition-colors truncate max-w-[150px]"
              >
                {label}
              </Link>
            )}
          </div>
        );
      })}
    </nav>
  );
}
